<template lang="pug">
include /mixins.pug

+b-context("i-filter")
  +e.block.last(:class="{ open: isOpen }")
    +e.head(
      @click="toggleBlock"
      @keydown.enter.prevent="toggleBlock"
      @keydown.space.prevent="toggleBlock"
      role="button"
      tabindex="0"
      :aria-expanded="String(isOpen)"
    )
      +e.head-title
        +e.SPAN.uppercase {{ _('Сортировка') }}

    +e.body(v-show="isOpen")
      +e.option
        +e.INPUT.control(
          type="radio"
          name="sorting"
          :id="'sorting-default'"
          value=""
          v-model="checked"
          @change="submit"
        )
        +e.LABEL.label(:for="'sorting-default'") {{ _('По умолчанию') }}
      +e.option(v-for="choice in choices" :key="choice.slug")
        +e.INPUT.control(
          type="radio"
          name="sorting"
          :id="`sorting-${choice.slug}`"
          :value="String(choice.slug)"
          v-model="checked"
          @change="submit"
        )
        +e.LABEL.label(:for="`sorting-${choice.slug}`") {{ choice.label }}
</template>

<script>
export default {
  name: 'FilterSorting',

  props: {
    value: { default: '' },
    filters: { type: Object, default: () => ({ filters: {} }) },
    choices: { type: Array, default: () => [] },
    autoOpenWhenSelected: { type: Boolean, default: true },
  },

  data() {
    return {
      checked: '',
      isOpen: false,
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(nval) {
        this.checked = this.normalize(nval)
        if (this.autoOpenWhenSelected) this.isOpen = !!this.checked;
      },
    },
  },

  mounted() {
    this.checked = this.normalize(this.value)
  },

  methods: {
    normalize(v) {
      if (v == null || v === '') return ''
      if (Array.isArray(v)) {
        const first = v[0]
        return first != null ? String(first) : ''
      }
      return String(v)
    },

    submit() {
      this.$nextTick(() => {
        this.filters.order = this.checked ? [this.checked] : ''
        this.$emit('input', this.filters)
      })
    },
    toggleBlock() {
      this.isOpen = !this.isOpen;
    },
  },
}
</script>
